import React from 'react';

export default class ErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = { hasError: false, error: null, errorInfo: null };
    }

    static getDerivedStateFromError(error) {
        // Update state so the next render will show the fallback UI.
        return { hasError: true };
    }

    componentDidCatch(error, errorInfo) {
        // You can also log the error to an error reporting service
        // logErrorToMyService(error, errorInfo);
        this.setState({
            error: error,
            errorInfo: errorInfo
        })
    }

    render() {
        if (this.state.hasError || this.state.error) {
            // You can render any custom fallback UI
            return (
                <div className="card-header bg-transparent">
                    <div className="row align-items-center">
                        <div className="col">
                            <h2 className="mb-1">Something Went Wrong</h2>
                            <h6 className="text-uppercase text-muted ls-1 mb-0">Some Issues While Loading...</h6>
                        </div>
                    </div>
                </div>
            );
        }

        return this.props.children;
    }
}
